export default __webpack_public_path__ + "static/media/ICSE Mathematics.fb204c41.pdf";